import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsSystem, RotatableComponent } from '@inter-ikea-storageone/range';
import { RotateOrientation } from '../../types';
/**
 * None of our frames should be rotatable when they are attached to the wall
 * This system will remove the RotatableComponent when attached to wall and add the component back again when on the floor.
 */
export class HandleRotatableSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'HandleRotatableSystem', ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
    }
    onAdd(entity) {
        const connection = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection;
        if (entity.hasComponent(RotatableComponent.id) &&
            connection?.guestConnector.key === 'attach-to-wall') {
            entity.removeComponent(RotatableComponent.id);
        }
    }
    onUpdate(entity) {
        const connectorName = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)?.highestPriorityConnection?.guestConnector.key;
        if (entity.hasComponent(RotatableComponent.id) && connectorName === 'attach-to-wall') {
            entity.removeComponent(RotatableComponent.id);
            return;
        }
        const productRef = this.coreApi.entities.getProductRef(entity);
        if (!productRef)
            return;
        const rotateOrientation = Object.values(RotateOrientation);
        if (rotateOrientation.some(orientation => productRef.includes(orientation)) &&
            connectorName === 'attach-to-wall-floor-edge') {
            entity.addComponent(new RotatableComponent());
        }
    }
    onRemove() { }
}
//# sourceMappingURL=HandleRotatableSystem.js.map